import React, { useEffect, useState } from "react";
import { FaRegEdit } from "react-icons/fa";
import { AiOutlineDelete } from "react-icons/ai";
import imgw1 from "../../../assests/images/imagew1.png";
import imgw2 from "../../../assests/images/imagew2.png";
import imgw3 from "../../../assests/images/imagew3.png";
import Table from "../../../components/table";
import UpdateScreenModal from "./updateScreenModal";
import RemoveScreenModal from "./removeScreenModal";
import AddMoreScreen from "./addMoreScreen";
import {
  fetchCms,
  uploadCms,
  updateCms,
  deleteCms,
} from "../../../api/endpoint";
import axios from "axios";
import { useSelector } from "react-redux";
import Loader from "../../../components/loader";
import { API_BASE_URL } from "../../../api/endpoint";
import toast from "react-hot-toast";

const onboardingData = [
  {
    img: imgw1,
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
  },
  {
    img: imgw2,
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
  },
  {
    img: imgw3,
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
  },
];

const WelcomeScreens = () => {
  const [loading, setLoading] = useState(false);
  const [welcomeScreens, setWelcomeScreens] = useState();
  const [isUpdateOpen, setIsUpdateOpen] = useState(false);
  const [isRemoveOpen, setIsRemoveOpen] = useState(false);
  const [isAddMoreOpen, setIsAddMoreOpen] = useState(false);
  const [selectedScreen, setSelectedScreen] = useState();
  const [selectedImgUrl, setSelectedImgUrl] = useState("");
  const [selectedText, setSelectedText] = useState("");
  const { auth } = useSelector((state) => state.login);

  useEffect(() => {
    fetchWelcomeScreens();
  }, []);

  const fetchWelcomeScreens = async () => {
    try {
      setLoading(true);
      const response = await axios.get(fetchCms, {
        params: { type: "WELCOME_SCREEN" },
        headers: { Authorization: `Bearer ${auth}` },
      });
      const screens = response?.data?.map((screen) => ({
        id: screen?.id,
        img: (
          <img
            src={`${API_BASE_URL}public/images/${screen?.fileName}`}
            style={{ height: "10rem" }}
          />
        ),
        text: screen?.text,
        actions: () =>
          getActionButtons(
            screen?.id,
            `${API_BASE_URL}public/images/${screen?.fileName}`,
            screen?.text
          ),
      }));
      setWelcomeScreens(screens);
    } catch (error) {
      console.error("Error fetching welcome screens", error);
    } finally {
      setLoading(false);
    }
  };

  const uploadAndSaveImg = async (img, text, type) => {
    let fileName = img;
    if (img !== null) {
      const formData = new FormData();
      formData.append("file", img);
      try {
        setLoading(true)
        const uploadResponse = await axios.post(uploadCms, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        if (uploadResponse.status === 200) {
          fileName = uploadResponse.data.message;
          fileName = fileName?.split("/")?.pop();
        }
      } catch(error) {
        toast.error("Error uploading image")
        console.error("Error uploading image", error)
        return
      } finally {
        setLoading(false)
      }   
    }
    try {
      setLoading(true)
      const payload = {
        fileName,
        text: text,
        imageType: "WELCOME_SCREEN",
      };
      let response;
      if (type == "update") {
        response = await axios.post(updateCms, payload, {
          params: { id: selectedScreen },
          headers: { Authorization: `Bearer ${auth}` },
        });
      } else {
        response = await axios.post(updateCms, payload, {
          headers: { Authorization: `Bearer ${auth}` },
        });
      }
      if (response.status === 200) {
        toast.success("Image saved successfully");
        fetchWelcomeScreens();
      }
    } catch (error) {
      toast.error("Error saving image to DB");
      console.error("Error saving image to DB:", error);
    } finally {
      setLoading(false)
    }
  };

  const deleteWelcomeScreenCms = async () => {
    const response = await axios.delete(deleteCms, {
      params: { id: selectedScreen },
      headers: { Authorization: `Bearer ${auth}` },
    });
    if (response?.status == 200) {
      toast.success("Welcome Screen deleted");
      fetchWelcomeScreens();
    }
  };

  const getActionButtons = (id, imgUrl, text) => {
    return (
      <div className="d-flex justify-content-center align-items-center">
        <button
          className="btn p-0 me-2"
          onClick={() => {
            setSelectedScreen(id);
            setIsUpdateOpen(true);
            setSelectedImgUrl(imgUrl);
            setSelectedText(text);
          }}
        >
          <FaRegEdit size={26} />
        </button>
        <button
          className="btn p-0"
          onClick={() => {
            setSelectedScreen(id);
            setIsRemoveOpen(true);
            setSelectedImgUrl(imgUrl);
            setSelectedText(text);
          }}
        >
          <AiOutlineDelete size={26} />
        </button>
      </div>
    );
  };

  const headings = [
    // { name: "ID", fieldName: "id", isSortable: false, sortKey: "none" },
    { name: "Image", fieldName: "img", isSortable: false, sortKey: "none" },
    { name: "Text", fieldName: "text", isSortable: false, sortKey: "none" },
    {
      name: "Actions",
      fieldName: "actions",
      isSortable: false,
      sortKey: "none",
    },
  ];

  return (
    <div>
      {/* <div className="d-flex justify-content-end mb-3 gap-3">
        <Button text="+ Add More" callBack={() => setIsAddMoreOpen(true)} />
      </div> */}
      <Table
        headings={headings}
        data={welcomeScreens}
        enablePagination={false}
        addBtnText="+ Add Welcome Screen"
        addCallback={() => setIsAddMoreOpen(true)}
        card={true}
      />
      <UpdateScreenModal
        isUpdateOpen={isUpdateOpen}
        closeUpdateModal={() => setIsUpdateOpen(false)}
        uploadAndSaveImg={uploadAndSaveImg}
        selectedImgUrl={selectedImgUrl}
        selectedText={selectedText}
      />
      <RemoveScreenModal
        isRemoveOpen={isRemoveOpen}
        closeRemoveModal={() => setIsRemoveOpen(false)}
        deleteWelcomeScreenCms={deleteWelcomeScreenCms}
        selectedImgUrl={selectedImgUrl}
        selectedText={selectedText}
      />
      <AddMoreScreen
        isAddMoreOpen={isAddMoreOpen}
        closeAddMoreModal={() => setIsAddMoreOpen(false)}
        uploadAndSaveImg={uploadAndSaveImg}
      />
      {loading && <Loader />}
    </div>
  );
};

export default WelcomeScreens;
